

define(['angular', 'squid/index', './directive'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-pay-upon-invoice.route', ['squid', 'hermes.page.xo-pay-upon-invoice.directive']).factory('$PayUponInvoiceRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('PayUponInvoiceRoute', {
      name: 'pay-upon-invoice',
      directive: 'xo-pay-upon-invoice-page',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'payment.payWithCard',

      trackingData: {
        templateName: 'pay-upon-invoice.dust',
        pageGoal: 'Payment Start',
        pageQualifier: 'pay-upon-invoice',
        buzname: {
          'pay-upon-invoice': {
            'pagename': '%::fullpage-pay-upon-invoice',
            'pagename2': '%::fullpage-pay-upon-invoice:guest:hermes:',
            'version': 'pay-upon-invoice:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: []
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay-upon-invoice/route.js
// module id = ./pages/xo-pay-upon-invoice/route.js
// module chunks = 0